const appConfig = {
  "name": "visiting-student-v2",
  "version": "0.1.0",
  "stage": "prod",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6sh93rjqnQuszg697",
    "clientId": "206kjgh8js00r7eape14d3oem",
    "redirectUris": [
      "https://vs-admin-mr.atlas-apps.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://vs-admin-mr.atlas-apps.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "digital-id/search",
      "digital-id/user",
      "email",
      "offline_access",
      "openid",
      "phone",
      "profile",
      "user/admin.visiting-student"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_bCu6BU8d2",
    "userPoolWebClientId": "206kjgh8js00r7eape14d3oem",
    "oauth": {
      "domain": "atlas-auth.mit.edu",
      "scope": [
        "digital-id/search",
        "digital-id/user",
        "openid",
        "profile",
        "user/admin.visiting-student",
        "visitor/admin"
      ],
      "redirectUris": [
        "https://vs-admin-mr.atlas-apps.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://vs-admin-mr.atlas-apps.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;